<template>
  <div></div>
</template>

<script>
export default {
  name: "DevicePush"
};
</script>
